<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getDiess" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-sm="4" label-cols-lg="3" label="Code"
							label-for="filter-code" size="sm" :model.sync="filter.code" />
						<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name"
							label-for="filter-name" size="sm" :model.sync="filter.name" />
						<app-input-textbox id="fieldset-dies-long" label-cols-sm="4" label-cols-lg="3" label="Long"
							label-for="filter-dies-long" size="sm" :model.sync="filter.diesLong" />
						<app-input-textbox id="fieldset-wide" label-cols-sm="4" label-cols-lg="3" label="Wide"
							label-for="filter-wide" size="sm" :model.sync="filter.wide" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-height" label-cols-sm="4" label-cols-lg="3" label="Height"
							label-for="filter-height" size="sm" :model.sync="filter.height" />
						<app-input-textbox id="fieldset-standar-preventive" label-cols-sm="4" label-cols-lg="3"
							label="Standard Preventive (Total Stroke)" label-for="filter-standar-preventive" size="sm"
							:model.sync="filter.standarPreventive" />
						<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Uom" id="filter-" size="sm"
							:model.sync="filter.uomId" @input="getUoms" @focus="getUoms" />
						<app-input-textarea id="fieldset-remark" label-cols-sm="4" label-cols-lg="3" label="Remark"
							label-for="filter-remark" size="sm" :model.sync="filter.remarkMultiple" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getDiess"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span>
							Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Dies</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)"
								href="files/dies/Dies.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download
								Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)"
								@click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload
								Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)"
								@click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To
								Pdf</b-dropdown-item>
						</b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
							opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
							<b-button class="btn-create btn-fill-success" to="/dies/create" size="sm"> <b-icon-plus-square
									class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
								opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
								<b-button class="btn-create btn-fill-success" to="/dies/create" size="sm">
									<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download
							class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton" :show="isDeleteBusy" rounded opacity="0.6" spinner-small
						spinner-variant="primary" class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash
									class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' |
							countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-dies"
					:class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true"
					:no-local-sorting="true" :items="diess" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="diess.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Code" class="table-filter">
							<b-form-input id="input-code-table" @input="getDiessWithoutLoading" v-model="filter.code"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Name" class="table-filter">
							<b-form-input id="input-name-table" @input="getDiessWithoutLoading" v-model="filter.name"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Long" class="table-filter">
							<b-form-input id="input-dies-long-table" @input="getDiessWithoutLoading"
								v-model="filter.diesLong" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Wide" class="table-filter">
							<b-form-input id="input-wide-table" @input="getDiessWithoutLoading" v-model="filter.wide"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Height" class="table-filter">
							<b-form-input id="input-height-table" @input="getDiessWithoutLoading" v-model="filter.height"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Standard Preventive (Total Stroke)" class="table-filter">
							<b-form-input id="input-standar-preventive-table" @input="getDiessWithoutLoading"
								v-model="filter.standarPreventive" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Uom" class="table-filter">
							<v-select append-to-body label="code" :options="uoms" :value="filter.uomId"
								:reduce="item => item.id" v-model="filter.uomId" :filterable="true"
								@input="getDiessWithoutLoading" @search="getUoms"></v-select>
						</b-th>
						<b-th stacked-heading="Remark" class="table-filter">
							<b-form-input id="input-remark-table" @input="getDiessWithoutLoading" v-model="filter.remark"
								size="sm"></b-form-input>
						</b-th>

						<b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all"
								class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(code)="row">
						<a @click="() => ($router.push({ name: 'diesdetail', params: { id: row.item.id } }))"
							class="a-link-detail">
							{{ row.item.code != null && row.item.code != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.code.slice(0, 30) + (row.item.code.length > 30 ? "..." : "") : row.item.code : "" }}
						</a>
					</template>

					<template v-slot:cell(uom)="row">
						{{ row.item.uom != null ? row.item.uom.code : "" }}
					</template>
					<template v-slot:cell(remark)="row">
						<app-long-text :id="'remark-' + row.index"
							:text="row.item != null ? (row.item.remark != null && row.item.remark != '' ? row.item.remark : '') : ''" />
					</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)"
								@change="toggleSelect(Number(row.item.id))"
								:checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button> -->
							<b-button class="d-sm-none d-md-inline btn-outline-success" @click="showPopUpQr(row.item)"
								size="sm">Print
								QR</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-textbox id="fieldset-dies-long" label-cols-lg="12" label="Long"
								label-for="input-dies-long" size="sm" :model.sync="row.item.diesLong" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textbox id="fieldset-wide" label-cols-lg="12" label="Wide" label-for="input-wide"
								size="sm" :model.sync="row.item.wide" :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-height" label-cols-lg="12" label="Height"
								label-for="input-height" size="sm" :model.sync="row.item.height" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textbox id="fieldset-standar-preventive" label-cols-lg="12"
								label="Standard Preventive (Total Stroke)" label-for="input-standar-preventive" size="sm"
								:model.sync="row.item.standarPreventive" :isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.uomId" label="Uom"
								:selected="row.item.uom != null ? row.item.uom.code : ''" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
								label-for="input-remark" size="sm" :model.sync="row.item.remark" :isEditable="false"
								:isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(diessPaging != null ? diessPaging.dataCount : 0)"
									:per-page="(diessPaging != null ? diessPaging.pageSize : 0)" aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId" @resetModalMethod="resetModal"
			label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-dies.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}

::v-deep #table-list-dies.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}
</style>
<script>
import Dies from '@/models/Dies/Dies';
import DiesList from '@/models/Dies/DiesList';
import DiesFilter from '@/filters/Dies/DiesFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import UomFilter from '@/filters/Uom/UomFilter';
import Uom from '@/models/Uom/Uom';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components: {
		Dies,
		DiesList,
		DiesFilter,
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "code": {}, "class": "th-code first-child", "label": "Code", key: 'code', sortable: true },
				{ "name": {}, "class": "th-name", "label": "Name", key: 'name', sortable: true },
				{ "diesLong": {}, "class": "th-dies-long last-child", "label": "Long", key: 'diesLong', sortable: true },
				{ "wide": {}, "class": "th-wide d-stack-none", "label": "Wide", key: 'wide', sortable: true },
				{ "height": {}, "class": "th-height d-stack-none", "label": "Height", key: 'height', sortable: true },
				{ "standarPreventive": {}, "class": "th-standar-preventive d-stack-none", "label": "Standard Preventive (Total Stroke)", key: 'standarPreventive', sortable: true },
				{ "uom": {}, "class": "th-uom d-stack-none", "label": "Uom", key: 'uom', sortable: true },
				{ "remark": {}, "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: true },

				{ "actions": { "class": "th-actions", "label": "" } }
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			diess: [],
			diessPaging: {},
			uoms: [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	}, methods: {
		showPopUpQr(item) {

		},
		getDiess: async function () {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			Dies.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.diess = result.data
						this.diessPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getDiessWithoutLoading: async function () {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			Dies.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.diess = result.data
						this.diessPaging = result
					}
				})
				.catch(error => { });
		},
		getUoms: async function (input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Uom.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.uoms = result.data
					}
				})
				.catch(error => { });
		},

		resetFilter() {
			this.filter = new DiesFilter();
			this.getDiess();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getDiess();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				Dies.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			Dies.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			console.log('this.filter', this.filter);
			Dies.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					console.log('result ', result);
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},

		deleteData(id) {
			Dies.deleteData(this, id).then(result => {
				if (result) {
					this.getDiess();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				Dies.deleteMultipleData(this).then(result => {
					this.getDiess();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableDiesParent = document.getElementById('table-list-dies').parentNode;
			tableDiesParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableDiesParent.scrollWidth - tableDiesParent.offsetWidth) == Math.ceil(tableDiesParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableDiesParent = document.getElementById('table-list-dies').parentNode;
			tableDiesParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableDiesParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new DiesFilter();
		this.getUoms()
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Dies"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getDiess();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getDiess();
			}
		},
		sortDesc: {
			handler: function () {
				this.getDiess();
			}
		},
		currentPage: {
			handler: function () {
				this.getDiess();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getDiess();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				Dies.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "diesindex") {
					this.getDiessWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "dies").first();
		},
		isShowDeleteButton: function () {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
